import { useState, useEffect } from "react";
import { createAdminInServer, runMigrationsInServer } from "./adminPanelService";
import { toast, ToastContainer } from "react-toastify";

const AdminPanel = () => {
    const [isLoading, setIsloading] = useState(true);

    useEffect(() => {

    }, []);


    const runMigrations = async (e) => {
        try {
            setIsloading(true);
            await runMigrationsInServer();
            setIsloading(false);
        } catch (err) {
            toast(err.response?.data?.message);
            setIsloading(false);
        }
    };

    const createAdmin = async (e) => {
        try {
            setIsloading(true);
            await createAdminInServer();
            setIsloading(false);
        } catch (err) {
            toast(err.response?.data?.message);
            setIsloading(false);
        }
    };

    return (
        <div className="row m-0">
            <input type="button" onClick={() => runMigrations()} className="btn btn-primary mt-2" value="اجرای میگریشن ها" />
            <input type="button" onClick={() => createAdmin()} className="btn btn-primary mt-2" value="ساخت کاربر ادمین" />
            <input type="button" onClick={() => window.location.replace('/admin/schools')} className="btn btn-primary mt-2" value="لیست مدارس" />
            <input type="button" onClick={() => window.location.replace('/admin/users')} className="btn btn-primary mt-2" value="لیست کاربران" />
            <ToastContainer />
        </div>
    );
};

export default AdminPanel;
